import { render } from "./message-video.vue?vue&type=template&id=207acd6d&scoped=true&ts=true"
import script from "./message-video.vue?vue&type=script&lang=ts"
export * from "./message-video.vue?vue&type=script&lang=ts"

import "./message-video.vue?vue&type=style&index=0&id=207acd6d&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207acd6d"]])

export default __exports__